import { AppRegistry } from "react-native";
import { App } from "./App";
import "./i18n";
import "./styles.css";

const root = document.getElementById("root");
if (!root) throw new Error("Admin client root element is missing");

AppRegistry.registerComponent("ToyConsole", () => App);
AppRegistry.runApplication("ToyConsole", { rootTag: root });
